import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import ClienteList from "./ClienteList";
import Template from "../../layout/Template";
import { ClienteService } from "../../services/api/Clientes/ClienteService"
import { useEffect, useState } from "react";
import ModalSimNao from "../../components/ModalSimNao";
import PaginacaoLinks from "../../components/Paginacao/PaginacaoLinks";
import Loading from "../../components/Loader/Loading"
import { usePermissoes } from "../../hooks/usePermissoes";
import PermissoesComponent from "../../components/PermissaoComponent";

const Clientes = () => {

    const [paginacao, setPaginacao] = useState({
        currentPage: null,
        totalPages: null,
        nextPage: null,
        prevPage: null

    })

    const [showModalSN, setShowModalSN] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [search, setSearch] = useState('')
    const [timeDelay, setTimeDelay] = useState(null)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes,isLoadingPerm } = usePermissoes([
        { secoesId: 3, acoesId: 1 },
        { secoesId: 3, acoesId: 2 },
        { secoesId: 3, acoesId: 3 },
        { secoesId: 3, acoesId: 4 }
    ])
    const fecthCliente = async (page) => {
        setIsloading(true);
        const res = await ClienteService.getAll(search, page)
        if (res != undefined) {
            const data = res.data;
            setClientes(data)
            setPaginacao({
                currentPage: res.meta.current_page,
                totalPages: Math.ceil(res.meta.total / res.meta.per_page),
                nextPage: (res.meta.current_page + 1),
                prevPage: (res.meta.current_page - 1)
            })
        }
        setIsloading(false);
    }
    const [clientes, setClientes] = useState([])

    useEffect(() => {
        fecthCliente()
    }, [])



    const handleCloseModalSn = () => {
        setShowModalSN(false)
        setIdDelete(null)
    }
    const handleDelete = (idCliente) => {
        setIdDelete(idCliente)
        setShowModalSN(true)

    }
    const handleConfirmDelete = async () => {
        setIsloading(true)
        const data = await ClienteService.deleteById(idDelete)
        fecthCliente()
        console.log(data)
        setIdDelete(null)
        setShowModalSN(false)
        setIsloading(false)
    }


    const handleChangeBusca = (e) => {

        clearTimeout(timeDelay)

        setSearch(e.target.value)

        let time = setTimeout(function () {

            if (e.target.value.length >= 3) {
                fecthCliente()

            } else {
                fecthCliente()
            }

        }, 300)
        setTimeDelay(time);




    }
    const onClickPage = async (page) => {
        await fecthCliente(page)
    }
    return (

        <>
            <Template>
                <div className="box-fundo">


                <Row style={{ flexDirection: 'row' }}>
                    <Col xs={12} md={6} >
                        <h3>Clientes

                            <Button variant="success" size="sm" style={{ marginLeft: '15px' }} onClick={() => setIsloading(true)} href="/admin/clientes/cadEdit">+ Adicionar</Button>
                        </h3>
                    </Col>
                    <Col xs={12} md={6} >


                        <Form.Control type="text" placeholder="Buscar  cliente" size="sm" onChange={(e) => handleChangeBusca(e)} />
                    </Col>
                </Row>


                {(isLoading) ? <Loading /> : (

                    <>
                        {(!listPermissoes?.ver &&   !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                            <>

                                {(clientes.length > 0) ? (
                                    <>
                                    <div className="table-responsive">

                                        <Table striped  hover size="sm" style={{ marginTop: '15px' }}>
                                            <thead>
                                                <tr>
                                                    <th>Cod.</th>
                                                    <th>Nome</th>
                                                    <th>Animais</th>
                                                    <th>Observações</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ClienteList listPermissoes={listPermissoes} setIsloading={setIsloading} listCliente={clientes} fecthCliente={fecthCliente} handleDelete={handleDelete} />
                                            </tbody>
                                        </Table>
                                         </div>
                                   
                                        <PaginacaoLinks totalPages={paginacao?.totalPages}
                                            currentPage={paginacao?.current_page}
                                            onClickPage={onClickPage}
                                        ></PaginacaoLinks>
                                    </>) : <div className="alert alert-warning text-center">Sem clientes registrados</div>}
                            </>)}
                    </>)}
                    
                </div>
                <ModalSimNao show={showModalSN} handleClose={() => setShowModalSN(false)} handleConfirm={() => handleConfirmDelete()}>Tem certeza que deseja excluir este cliente?</ModalSimNao>
            </Template>

        </>


    )
}

export default Clientes;